module.exports = __webpack_public_path__ + "a22e59c5aa2459c23bd136ecc291e58e.svg";